<template>
  <div id="table-row" class="flex align-center">
    <div class="table-column">
      <input
        v-model="isSaleSelected"
        :disabled="!isSaleSelectable(sale.id)"
        type="checkbox"
      >
    </div>
    <p class="table-column">{{ sale.formatted_total }}</p>
    <p class="table-column">{{ sale.license_plate }}</p>
    <p class="table-column dspl-none-m dspl-none-sm">{{ sale.model }}</p>
    <p class="table-column dspl-none-m dspl-none-sm">{{ sale.brand }}</p>
    <p class="table-column dspl-none-m dspl-none-sm">{{ sale.year }}</p>
    <p class="table-column dspl-none-m dspl-none-sm">{{ sale.payment_method }}</p>
    <p class="table-column dspl-none-m dspl-none-sm">{{ sale.status }}</p>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'TableRow',
  props: {
    sale: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      check: false
    }
  },
  computed: {
    ...mapGetters('invoiceableSales', [
      'isSaleSelectable'
    ]),
    isSaleSelected: {
      get () { return this.$store.getters['invoiceableSales/isSaleSelected'](this.sale.id) },
      set (value) {
        if (value) {
          this.selectSale(this.sale.id)

          return
        }

        this.removeSelectedSale(this.sale.id)
      }
    }
  },
  methods: {
    ...mapActions('invoiceableSales', [
      'removeSelectedSale',
      'selectSale'
    ])
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants.scss';

#table-row {
  width: 100%;

  &:not(:last-child) {
    border-bottom: 1px solid $grey;
  }
}

.table-column {
  text-align: center;
  margin: .75rem 0;
  width: calc(100% / 7);
}

@media screen and (max-width: 60rem) {
  .table-column {
    font-size: .75rem;
    width: calc(100% / 4)
  }
}
</style>
